const swiper = new Swiper(".swiper", {
    // Optional parameters
    direction: "horizontal",
    loop: false,
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

document.addEventListener("DOMContentLoaded", (event) => {
    // const count = 4;

    // for (let index = 1; index < count; index++) {
    //     const tab_btn = document.getElementById("tab" + index);
    //     const tab_text = document.querySelector(".tab-text" + index);
    //     const tab_image = document.querySelector(".tab-image" + index);

    //     if (index == 1) {
    //         tab_btn.classList.add("active");
    //         tab_text.style.display = "block";
    //         tab_image.style.display = "block";
    //     }

    //     tab_btn.addEventListener("click", () => {
    //         for (let i = 1; i < count; i++) {
    //             const btn = document.getElementById("tab" + i);
    //             const text = document.querySelector(".tab-text" + i);
    //             const image = document.querySelector(".tab-image" + i);

    //             if (i === index) {
    //                 btn.classList.add("active");
    //                 text.style.display = "block";
    //                 image.style.display = "block";
    //             } else {
    //                 btn.classList.remove("active");
    //                 text.style.display = "none";
    //                 image.style.display = "none";
    //             }
    //         }
    //     });
    // }

    const open_subscription = document.getElementById("open-subscription");
    const open_label = document.getElementById("open-label");
    const modal_overlay = document.getElementById("modal-overlay");
    const subscription_modal = document.getElementById("subscription-modal");
    const label_modal = document.getElementById("label-modal");
    const close_modal = document.querySelectorAll(".close-modal");

    if (open_subscription) {
        open_subscription.addEventListener("click", () => {
            label_modal.classList.remove("opened");
            modal_overlay.classList.add("opened");
            subscription_modal.classList.add("opened");
        });
    }

    if (open_label) {
        open_label.addEventListener("click", () => {
            subscription_modal.classList.remove("opened");
            modal_overlay.classList.add("opened");
            label_modal.classList.add("opened");
        });
    }

    close_modal.forEach((button) => {
        button.addEventListener("click", () => {
            modal_overlay.classList.remove("opened");
            subscription_modal.classList.remove("opened");
            label_modal.classList.remove("opened");
        });
    });
});
